import React from "react";
import { Card, Tag, Button, Typography, Popconfirm, Space } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { ItemModel } from "../model/orders.ui";
import {
  getOrderNo,
  getCustomerName,
  getOrderDate,
  getDeliveryDate,
  getTotalAmount,
  getStatusConfig,
} from "./orderListHelpers";

const { Text } = Typography;

export interface OrderMobileCardProps {
  order: ItemModel;
  onSelect: (order: ItemModel) => void;
  onDelete?: (order: ItemModel) => void;
}

export const OrderMobileCard: React.FC<OrderMobileCardProps> = ({
  order,
  onSelect,
  onDelete,
}) => {
  const statusConfig = getStatusConfig(order.status);

  return (
    <Card
      hoverable
      style={{ borderRadius: 10, border: "1px solid #f0f0f0", padding: 14 }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: 6,
        }}
      >
        <Text strong style={{ fontSize: 15, color: "#1677ff" }}>
          {getOrderNo(order)}
        </Text>
        <Tag color={statusConfig.color}>{statusConfig.label}</Tag>
      </div>

      <div style={{ fontSize: 13, color: "#595959", marginBottom: 4 }}>
        店舗: {/* Tên cửa hàng / chi nhánh */}<Text strong>{getCustomerName(order)}</Text>
      </div>

      <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 10 }}>
        注文日: {/* Ngày đặt hàng */}{getOrderDate(order)} | 納品希望: {/* Ngày giao hàng mong muốn */}{getDeliveryDate(order)}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: 8,
          borderTop: "1px dashed #f0f0f0",
        }}
      >
        <div>
          <Text type="secondary" style={{ fontSize: 11, display: "block" }}>
            合計金額 {/* Tổng tiền */}
          </Text>
          <Text strong style={{ fontSize: 16, color: "#000" }}>
            ¥{getTotalAmount(order).toLocaleString()}
          </Text>
        </div>
        <Space>
          <Button
            type="primary"
            ghost
            size="small"
            icon={<EyeOutlined />}
            onClick={() => onSelect(order)}
          >
            詳細を見る {/* Xem chi tiết */}
          </Button>
          {onDelete && (
            <Popconfirm
              title="注文の削除" /* Xóa đơn hàng */
              description="この注文を削除してもよろしいですか？" /* Bạn có chắc chắn muốn xóa đơn hàng này? */
              okText="削除" /* Xóa */
              cancelText="キャンセル" /* Hủy */
              okButtonProps={{ danger: true }}
              onConfirm={(e) => {
                e?.stopPropagation();
                onDelete(order);
              }}
              onCancel={(e) => e?.stopPropagation()}
            >
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
                onClick={(e) => e.stopPropagation()}
              >
                削除 {/* Xóa */}
              </Button>
            </Popconfirm>
          )}
        </Space>
      </div>
    </Card>
  );
};
